/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Body/Body.css";
import angelaidancinglogoNU from "../../Images/angelaidancinglogoNU.webp";
import MediaQuery from "react-responsive";
const Form = lazy(() => import("../../components/SignUpForm/SignUpForm"));
const Interior = lazy(() => import("../../components/Interior/Interior"));



export default function Body({ links }) {
  const imgCDNURL = process.env.REACT_APP_DENVER_CDN_URL;

  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col sm={12} md={12} xl={7} lg={7}>
              <div className="bannertextstag">
                <p className="mastertitle">
                  Free Lead Prospecting: The Rise of Ai<br />
                  <span className="mastertitlespan">Never Cold Call Again: Let AngelAi Work Her Magic</span>
                  <span className="mastertitlespanmobile">Never Cold Call Again:<br/>Let AngelAi Work Her Magic</span>
                </p>
              </div>
              <div className="angelailogocontmobile">
                <a href="https://angelai.com/"
                  target="_blank"
                  rel="noreferrer"
                  title="AngelAi"
                  className="angelailogoancher">
                  <img src={"https://d2b7dijo04ypct.cloudfront.net/NURecon2023/postevent/angelaidancinglogoNU.webp"} alt="AngelAi" className="angelailogo" />
                </a>
              </div>
              <div className="mstar-container">
                <p className="eventname" style={{ color: '#FFF' }}>Level up Your Real Estate Game:<br />
                  <span className="eventname1" >Catch the NU You Real Estate<br/>Conference Highlights</span></p>
              </div>
              <div className="angelailogocont">
                <a href="https://angelai.com/"
                  target="_blank"
                  rel="noreferrer"
                  title="AngelAi"
                  className="angelailogoancher">
                  <img src={"https://d2b7dijo04ypct.cloudfront.net/NURecon2023/postevent/angelaidancinglogoNU.webp"} alt="AngelAi" className="angelailogo" />
                </a>
              </div>
            </Col>
            <Col sm={12} md={12} xl={5} lg={5}>
              <div className="formsection">
                <Suspense fallback={<div />}>
                  <Form />
                </Suspense>
              </div>
            </Col>
          </Row>
          
          <MediaQuery query="(min-width: 992px)">
            <Suspense fallback={<div />}>
              <Interior links={links} />
            </Suspense>
          </MediaQuery>
        </Container>
        <div>
        <MediaQuery query="(max-width: 991px)">
        <p className="Relivetext"> Recapture the <br></br>Moments</p><br/>
        </MediaQuery>
  
    </div>
      </div>
    
    </>
    
  );
}
